import { useEffect } from 'react'
import { Analytics, ApiCallback, ApiOptions, IdentifyTraits } from 'hooks/useAnalytics'
import { useLDClient } from 'launchdarkly-react-client-sdk'

// This is a patch to ensure that the LaunchDarkly context is updated when the analytics identify is called

export const LaunchDarklyIdentify = () => {
    const ldClient = useLDClient()

    useEffect(() => {
        if (!ldClient) {
            console.info('[ld]: ldClient not found')
            return
        }

        const analytics = Analytics.getInstance()
        const updateContext = () => {
            console.log('[ld]: updateContext', analytics.pseudoId)
            const commonProperties = analytics.getCommonProperties()

            ldClient.identify({
                kind: 'user',
                key: analytics.pseudoId || 'anonymous',
                anonymous: !analytics.pseudoId,
                traits: {
                    browserName: commonProperties.browserName,
                    device: commonProperties.device,
                    platform: commonProperties.platform,
                    release: commonProperties.release,
                },
            })
        }

        // update context when analytics identify is called
        const originalIdentify = analytics.identify.bind(analytics)
        analytics.identify = (
            traits?: IdentifyTraits | ApiOptions | ApiCallback,
            options?: ApiOptions | ApiCallback,
            callback?: ApiCallback,
        ) => {
            originalIdentify(traits, options, callback)
            updateContext()
        }

        console.log('[ld]: initialized')

        // initial context update
        updateContext()

        return () => {
            analytics.identify = originalIdentify
        }
    }, [ldClient])

    return null
}
